var _polygon, _polygon2, _path, _path2, _path3, _path4, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyPana2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.01,
    y: 378.75,
    width: 104.15,
    height: 80.33,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.07,458.52c-.14,0-.26-17.91-.26-40s.12-40,.26-40,.26,17.91.26,40S245.21,458.52,245.07,458.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.35,
    y: 440.8,
    width: 7.98,
    height: 9.03,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.79,
    y: 378.96,
    width: 11.83,
    height: 17.14,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.79,
    y: 441.7,
    width: 11.83,
    height: 17.14,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.82,
    y: 358.61,
    width: 131.33,
    height: 101.29,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.24,459.18c-.14,0-.26-22.57-.26-50.42s.12-50.42.26-50.42.26,22.57.26,50.42S427.39,459.18,427.24,459.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.94,
    y: 436.84,
    width: 10.07,
    height: 11.38,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.88,
    y: 358.87,
    width: 14.92,
    height: 21.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.88,
    y: 437.98,
    width: 14.92,
    height: 21.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.46,361.59c5.32-2.74,11.58-3.1,17.48-2.12,3.17.52,6.47,1.47,8.63,3.85s2.56,6.57.09,8.62c-1.48,1.22-3.53,1.4-5.45,1.38-4.62-.06-9.74-.87-13.43,1.91-2.11,1.59-3.51,4.22-6,5s-5.24-.69-6.54-2.91a10.15,10.15,0,0,1-.74-7.51A11.45,11.45,0,0,1,81.46,361.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.28,338.08c3.25,4.64,9.57,3.11,12.5.27s4.17-6.94,5.29-10.85c2.58-8.95,5.17-18.34,3.26-27.45a15.19,15.19,0,0,0-3.51-7.46,8,8,0,0,0-7.54-2.51c-3.19.84-5.17,4-6.6,6.93a65.29,65.29,0,0,0-6.46,28.07c0,4.53.51,9.27,3.06,13",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.36,344.74c3.53-4.19,4.2-10.29,2.63-15.54s-5.12-9.71-9.21-13.36a49.6,49.6,0,0,0-16.48-9.72,17.58,17.58,0,0,0-7.42-1.26,7.77,7.77,0,0,0-6.22,3.76c-1.74,3.31-.07,7.32,1.73,10.6a125.87,125.87,0,0,0,10.82,16.49c3.25,4.18,7,8.31,11.91,10.2s10.09,1.67,12.71-1.76",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.06,408.1a10.07,10.07,0,0,0,.3-2.1c.15-1.54.33-3.47.56-5.76a84,84,0,0,1,1.29-8.44,64.62,64.62,0,0,1,3.07-10,37,37,0,0,1,5.09-9,19.22,19.22,0,0,1,6.43-5.35,18.1,18.1,0,0,1,5.42-1.68,9.88,9.88,0,0,0,2.1-.31,9.72,9.72,0,0,0-2.13,0,16.37,16.37,0,0,0-5.65,1.47,18.94,18.94,0,0,0-6.79,5.4,35.67,35.67,0,0,0-5.28,9.19,61.15,61.15,0,0,0-3,10.13,73.35,73.35,0,0,0-1.13,8.55c-.18,2.45-.25,4.43-.28,5.8A10,10,0,0,0,69.06,408.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.46,403.68a4.25,4.25,0,0,0,.06-1c0-.74,0-1.67,0-2.8,0-2.43,0-5.95.12-10.29.22-8.68,1-18,2.41-31.19,1.37-12.39,3.2-26.8,5.14-36.17.41-2.13.83-4.05,1.23-5.73s.69-3.14,1-4.31.48-2,.66-2.72a4.1,4.1,0,0,0,.17-1,4,4,0,0,0-.34.92c-.22.71-.49,1.59-.82,2.68s-.73,2.61-1.15,4.28-.9,3.59-1.35,5.72a317,317,0,0,0-5.41,33.56c-1.44,13.2-2.09,25.22-2.15,33.92,0,4.35,0,7.88.15,10.31.07,1.13.13,2.06.17,2.79A4.31,4.31,0,0,0,69.46,403.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52,380.5a18.8,18.8,0,0,0,0-2.93c-.11-1.88-.37-4.59-.9-7.92A104.22,104.22,0,0,0,66,358.11a95.33,95.33,0,0,0-4.83-13.66A72.62,72.62,0,0,0,47,322.39a35.08,35.08,0,0,0-3.34-3.1c-.51-.44-1-.87-1.42-1.21L41,317.19a17.72,17.72,0,0,0-2.47-1.58c-.14.19,3.49,2.33,8.07,7.2a76.6,76.6,0,0,1,13.82,22,106.14,106.14,0,0,1,4.85,13.53A117.56,117.56,0,0,1,68,369.76c.6,3.29,1,6,1.16,7.84A18.36,18.36,0,0,0,69.52,380.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.56 417.86 47.88 449.69 88.77 449.69 91.09 417.86 45.56 417.86",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.61,
    y: 405.32,
    width: 54.35,
    height: 12.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.61 448.47 41.61 451.94 44.17 451.94 95.07 451.94 95.07 448.47 41.61 448.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.67 457.68 44.17 451.56 93.12 451.56 90.2 457.68 46.67 457.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.33,428.26a1.48,1.48,0,0,1-.19.3c-.16.21-.37.48-.61.81l-2.38,3-.11.14-.1-.14-5.85-8.09h.33l-5.76,8.15-.18.26-.2-.24-6.83-8.13h.39l-.37.48-6.11,7.65-.21.26-.18-.27-5.77-8.15.34,0-7.1,8.08-.12.15-.1-.17L47,428.67c-.24-.4-.42-.73-.57-1a1.55,1.55,0,0,1-.18-.36,1.54,1.54,0,0,1,.24.32l.63.95,2.33,3.67-.22,0,7-8.18.17-.21.16.22,5.82,8.12H62l6.09-7.67c.13-.16.26-.32.37-.47l.2-.25.2.24,6.81,8.15h-.38l5.82-8.11.17-.24.16.24c2.31,3.29,4.27,6.08,5.73,8.18h-.21l2.48-3c.27-.31.49-.56.66-.77A2.27,2.27,0,0,1,90.33,428.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.66,417.65c0,.14-10.25.26-22.88.26s-22.88-.12-22.88-.26,10.24-.25,22.88-.25S91.66,417.51,91.66,417.65Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.15,
    y: 56.84,
    width: 8.38,
    height: 41.7,
    transform: "translate(-0.41 2.01) rotate(-0.31)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 56.99,
    width: 21.7,
    height: 23.02,
    transform: "translate(-0.36 1.65) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.1,
    y: 56.87,
    width: 21.7,
    height: 23.02,
    transform: "translate(-0.36 1.77) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.47,63.4q21.64.18,43.3-.2a.23.23,0,0,0,0-.46c-14.42-.08-28.88,0-43.3.27a.2.2,0,0,0,0,.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.96,
    y: 79.67,
    width: 39.43,
    height: 18.76,
    transform: "translate(-0.47 1.63) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.2,
    y: 79.46,
    width: 39.43,
    height: 18.76,
    transform: "translate(-0.47 1.84) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.94,85c26.19.29,52.47,0,78.67-.39a.23.23,0,0,0,0-.46c-26.19-.14-52.48-.13-78.67.45a.2.2,0,0,0,0,.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.19,
    y: 98.54,
    width: 152.76,
    height: 6.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.2,
    y: 101.77,
    width: 6.2,
    height: 22.93,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.77,
    y: 101.77,
    width: 6.2,
    height: 22.93,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.37,
    y: 41.29,
    width: 8.38,
    height: 57.35,
    transform: "translate(-0.37 2.05) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.79,
    y: 51.98,
    width: 13.02,
    height: 46.48,
    transform: "translate(-0.4 2.11) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.6,60.9a92.25,92.25,0,0,1-13,0,96.43,96.43,0,0,1,13,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.6,59a48.59,48.59,0,0,1-6.51.22,48.72,48.72,0,0,1-6.51-.22,92.25,92.25,0,0,1,13,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.6,91.43a92.25,92.25,0,0,1-13,0,96.43,96.43,0,0,1,13,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.6,89.48a96.43,96.43,0,0,1-13,0,92.25,92.25,0,0,1,13,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.3,85.22c-.12,0-.22-4.69-.22-10.47s.1-10.48.22-10.48.23,4.69.23,10.48S393.43,85.22,393.3,85.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.75,
    y: 63.36,
    width: 14.17,
    height: 35.08,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.28,
    cy: 51.06,
    r: 2.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.54,
    y: 57.69,
    width: 1.49,
    height: 34.12,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.66,459.35c0,.15-96.12.26-214.65.26s-214.67-.11-214.67-.26,96.1-.26,214.67-.26S464.66,459.21,464.66,459.35Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.21,92.35a32,32,0,0,1,7.22,20.46c-.05,4.22-.83,8.87,1.63,12.3,1.86,2.6,5.26,3.91,6.77,6.73,1.82,3.39.27,7.68,1.39,11.36,1.58,5.22,7.7,7.41,11.33,11.48a14.52,14.52,0,0,1,3,13.28,14.92,14.92,0,0,1-9.38,9.92,9.72,9.72,0,0,1-7.42-.12c-2.45-1.22-4-3.73-5.2-6.18-2.41-4.82-23.58-30.87-24.78-36.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.81,86.21c-8.66-1.4-17,4.35-20.63,12.33s-3.75,17-4,25.8-.89,17.92-5.36,25.46c-2.84,4.79-7.24,9-7.93,14.51-.62,4.94,1.94,9.92,1.09,14.83-.74,4.28-4,8-3.87,12.33.16,5.22,5.53,9.15,10.74,9.29s10.09-2.59,14.18-5.83a54.5,54.5,0,0,0,15.57-19.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.56,106.85A16.39,16.39,0,0,1,134.3,88.5c8.73-.84,16.5,5.67,17.81,14.35,1.15,7.61,2.13,15.29,2.1,18.08-.11,8.41-5,11.68-7,12.67a11.26,11.26,0,0,1-2.22.55h0a0,0,0,0,0,0,.06l1.86,9.66c.85,6.33-2.68,12-9,12.89s-11.29-3.94-12.26-10.27Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.39,106.53c-.14.2-1.25-.39-2.67-.18s-2.37,1.07-2.55.92,0-.4.44-.8a3.68,3.68,0,0,1,2-1,3.5,3.5,0,0,1,2.16.36C150.27,106.15,150.46,106.45,150.39,106.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.73,109.61c-.14.2-1.25-.4-2.68-.19s-2.36,1.08-2.54.93,0-.41.44-.8a3.68,3.68,0,0,1,2-1,3.58,3.58,0,0,1,2.16.37C137.6,109.23,137.8,109.52,137.73,109.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.92,117.24a9.39,9.39,0,0,1,2.25-.75c.36-.09.69-.21.72-.47a1.87,1.87,0,0,0-.4-1L144,112.36c-2.07-3.72-3.62-6.8-3.47-6.89s2,2.88,4,6.6c.51.92,1,1.8,1.44,2.63a2.17,2.17,0,0,1,.4,1.4.91.91,0,0,1-.52.62,2.54,2.54,0,0,1-.61.18A9,9,0,0,1,142.92,117.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.91,134.16s-5.43,1.25-12.91-1.88c0,0,3.23,6.95,13.42,4.48Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,105.88c-.08.41-1.53.43-3.17.88s-2.93,1.09-3.2.78c-.12-.15.06-.55.55-1a5.72,5.72,0,0,1,4.85-1.26C136.69,105.43,137,105.69,137,105.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.22,103.38c-.2.36-1.23.17-2.41.32s-2.15.54-2.43.23c-.12-.15,0-.49.38-.86a3.32,3.32,0,0,1,1.88-.82,3.41,3.41,0,0,1,2,.37C149.12,102.89,149.31,103.2,149.22,103.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.64,111.45a1.18,1.18,0,0,0,1.35,1,1.14,1.14,0,0,0,1-1.28,1.19,1.19,0,0,0-1.35-1A1.13,1.13,0,0,0,134.64,111.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,108.72a1.19,1.19,0,0,0,1.35,1,1.14,1.14,0,0,0,1-1.28,1.19,1.19,0,0,0-1.35-1A1.13,1.13,0,0,0,147.25,108.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.16,120a1.76,1.76,0,0,0-2.08.86,1.83,1.83,0,0,0,.25,2.11,1.61,1.61,0,0,0,2.08.15,2,2,0,0,0,.65-1.36,1.92,1.92,0,0,0-.32-1.36,1.09,1.09,0,0,0-1.27-.38",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,96a12.88,12.88,0,0,0-5.48-7.7,14.3,14.3,0,0,0-7.66-2.69,10.51,10.51,0,0,0-7.54,2.74A7.84,7.84,0,0,0,128,93.8l.16-1.4a5.1,5.1,0,0,0,0,3.53h0c.23.61.51,1.23.75,1.84a7.9,7.9,0,0,0,3.74,4.07,5.14,5.14,0,0,0,2.5.61,3,3,0,0,0,2.27-1.11,5,5,0,0,0,.54-3.58,8.55,8.55,0,0,0,2.73,3,3,3,0,0,0,3.76-.43c.82-1,.5-2.58,0-3.82a7.56,7.56,0,0,0,3.13,2.69,2.79,2.79,0,0,0,2.23.24,2.17,2.17,0,0,0,1.16-1.5A4.58,4.58,0,0,0,151,96Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.77,98.66c-.09,0-.07-1.19-.46-3a11.44,11.44,0,0,0-3.45-6.27,8.19,8.19,0,0,0-3.46-1.87,7.52,7.52,0,0,0-3.22-.08,9.29,9.29,0,0,0-2.78,1.15s.17-.25.61-.57a6.14,6.14,0,0,1,2.09-.94,7.48,7.48,0,0,1,3.41,0,8.47,8.47,0,0,1,3.7,2,11.19,11.19,0,0,1,3.47,6.59,14.47,14.47,0,0,1,.18,2.26A2.14,2.14,0,0,1,143.77,98.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.87,215.25,197.42,200s-19.69-25.83-19.28-26.33l-13.83,15.14L184.41,216,231,226.92l8-2.22C237.24,216.21,235.87,215.25,235.87,215.25Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.07,141.56l-5.24-2-22.62,2.87v4l-.65.08a46.34,46.34,0,0,0-13.85,5.38,23.64,23.64,0,0,0-11,24.07c.92,5.72,2.7,12.67,6.14,16.69,6.57,7.69,12.57-1.81,12.57-1.81s4.12,9.4,3.88,13.85c-.2,3.73-1.84,11.49-2.37,13.91a.73.73,0,0,0,.59.88l47.72,8.83.23-11.67-1.52-48L163.8,150S163.87,141.1,152.07,141.56Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.07 146.9 181.27 173.19 166.62 191.03 163.07 146.9",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,202.22a11.48,11.48,0,0,1-.07-1.7c0-1.18,0-2.73-.06-4.62a140.17,140.17,0,0,0-1.09-15.17c-.75-5.9-1.9-11.17-2.77-15l-1.06-4.5a11.59,11.59,0,0,1-.34-1.66,9.55,9.55,0,0,1,.54,1.61c.31,1,.73,2.57,1.21,4.47a122.55,122.55,0,0,1,2.94,15,117.7,117.7,0,0,1,.94,15.24c0,2-.05,3.54-.11,4.63A10,10,0,0,1,167,202.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.2,162.25c0,.08-1.38.07-3.59.18a58.14,58.14,0,0,0-8.58,1.11,59.45,59.45,0,0,0-8.32,2.39c-2.08.77-3.33,1.34-3.37,1.26a3.57,3.57,0,0,1,.84-.49c.55-.3,1.37-.68,2.4-1.11a46.58,46.58,0,0,1,17-3.52c1.12,0,2,0,2.65.06A3.16,3.16,0,0,1,122.2,162.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.35,174.28a8.85,8.85,0,0,1-2.27.5,50.47,50.47,0,0,1-11.17.38,9,9,0,0,1-2.3-.34,13.11,13.11,0,0,1,2.32,0c1.42,0,3.39,0,5.56,0s4.13-.22,5.55-.35A12.77,12.77,0,0,1,164.35,174.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.7,162.39a14.16,14.16,0,0,1-3.9,3.15,13.72,13.72,0,0,1-4.59,2c-.06-.14,2-1,4.32-2.48S172.6,162.27,172.7,162.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.35,150.2A18.86,18.86,0,0,1,153.94,155c0-.16,2.75-.58,5.91-1.93S165.25,150.07,165.35,150.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.34,194.64a4.77,4.77,0,0,1-.94.49c-.63.3-1.54.67-2.7,1.1a49.89,49.89,0,0,1-9.29,2.36,49.06,49.06,0,0,1-9.57.53c-1.23-.05-2.22-.14-2.9-.23a4.74,4.74,0,0,1-1.05-.19c0-.09,1.52,0,4,.06a58.78,58.78,0,0,0,18.73-2.88C164.9,195.13,166.31,194.56,166.34,194.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.71,208.19s-.14.1-.43.25L165,209c-1.1.52-2.73,1.2-4.77,2s-4.51,1.57-7.29,2.33a85.94,85.94,0,0,1-18.5,2.87c-2.88.11-5.47.1-7.65,0s-3.93-.26-5.14-.43l-1.39-.19a1.85,1.85,0,0,1-.48-.1,1.56,1.56,0,0,1,.49,0l1.4.09c1.21.1,3,.2,5.13.26s4.76,0,7.62-.1,6-.46,9.27-1,6.35-1.19,9.13-1.89,5.24-1.49,7.28-2.22,3.7-1.34,4.82-1.8l1.3-.51A2.41,2.41,0,0,1,166.71,208.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,420.78l-5.41,24.43L63.72,463.3a2.57,2.57,0,0,0,1.18,3.56h0a2.55,2.55,0,0,0,2.34-.11c4.58-2.64,21.39-12.47,21.68-14.28.35-2.09,7.42-25.39,7.42-25.39Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.9,466.86l24.43-16-.26,1a3.86,3.86,0,0,1-1.48,2.22c-2,1.43-7.57,5.27-20.27,12.69a2.56,2.56,0,0,1-2.42.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.26,441.77a1.55,1.55,0,0,0-.89,1.87,1.49,1.49,0,0,0,1.84.9,1.64,1.64,0,0,0,.94-2,1.55,1.55,0,0,0-2-.73",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.06,457.6a8,8,0,0,0-1.67-2.41A7.77,7.77,0,0,0,68.72,454c0-.07.35-.18.94-.12a4,4,0,0,1,2.08.92A3.88,3.88,0,0,1,73,456.66C73.17,457.23,73.12,457.6,73.06,457.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.53,460.43c-.14.08-.73-.9-1.9-1.57a18.79,18.79,0,0,0-2.3-.89,2.86,2.86,0,0,1,2.58.41C70.24,459.15,70.67,460.4,70.53,460.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3,454.22a24.4,24.4,0,0,0-2.76-2.62,24.8,24.8,0,0,0-3.4-1.73,5.71,5.71,0,0,1,3.72,1.28A5.6,5.6,0,0,1,77.3,454.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.57,446.93c-.1.13-1.31-.76-3-1.25s-3.22-.41-3.23-.58a6.38,6.38,0,0,1,6.27,1.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.34,439.8a12.65,12.65,0,0,0-3.13-1.39,12.68,12.68,0,0,0-3.42,0c0-.06.31-.3.95-.49a5.59,5.59,0,0,1,4.92,1C81.17,439.4,81.38,439.76,81.34,439.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.58,437.06a2.24,2.24,0,0,1,.2-.92,6.4,6.4,0,0,1,1.32-2.23,2.94,2.94,0,0,1,1.54-1.06,1.06,1.06,0,0,1,1.08.5,1.68,1.68,0,0,1,.11,1.2,3.63,3.63,0,0,1-3.88,2.5,4.22,4.22,0,0,1-3.49-3.12,1.5,1.5,0,0,1,.23-1.2,1,1,0,0,1,1.15-.27,3.65,3.65,0,0,1,1.4,1.23A7.39,7.39,0,0,1,79.43,436a2.3,2.3,0,0,1,.17.94,11.48,11.48,0,0,0-1.67-3,3.38,3.38,0,0,0-1.24-1,.54.54,0,0,0-.63.15,1,1,0,0,0-.1.79A3.77,3.77,0,0,0,79,436.5a3.15,3.15,0,0,0,3.33-2.07,1.25,1.25,0,0,0,0-.84.56.56,0,0,0-.59-.28,2.63,2.63,0,0,0-1.33.86A10.28,10.28,0,0,0,78.58,437.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "78.34 423.43 77.17 429.03 94.86 431.97 96.34 427.08 78.97 420.78 78.34 423.43"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M158,429.82l-1.46,19.52s19.36,8,19.44,11.68l-38-1.47,1-30.52Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.89,447.24a1.56,1.56,0,0,0-1.14,1.73,1.5,1.5,0,0,0,1.7,1.15,1.64,1.64,0,0,0,1.2-1.84,1.55,1.55,0,0,0-1.9-1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138,459.55l.22-3.08L174.57,459s1.67.8,1.43,2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M157.18,449.17c0,.19-.94.24-1.87.8s-1.45,1.32-1.62,1.24.15-1.14,1.29-1.8S157.23,449,157.18,449.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.1,451c0,.19-.78.47-1.44,1.23s-.87,1.58-1.06,1.57-.26-1.07.58-2S161.1,450.8,161.1,451Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.18,455.83c-.17,0-.39-.91.12-1.9s1.4-1.37,1.47-1.21-.48.68-.89,1.5S163.36,455.82,163.18,455.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,444.69c-.08.16-.92-.13-2-.1s-1.88.33-2,.17.72-.79,2-.81S157.12,444.55,157,444.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "157.73 433.69 157.47 437.17 138.82 436.27 138.95 432.25 157.73 433.69"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M157.25,440.74a3.45,3.45,0,0,1-1.9-.08,8.33,8.33,0,0,1-2-.69,9.18,9.18,0,0,1-1.07-.62,2.49,2.49,0,0,1-.56-.47.82.82,0,0,1,0-1,1,1,0,0,1,.83-.39,2.84,2.84,0,0,1,.71.12,6.68,6.68,0,0,1,1.16.46,6.52,6.52,0,0,1,1.71,1.21c.85.85,1.12,1.56,1.06,1.59s-.49-.54-1.36-1.25a8,8,0,0,0-1.66-1,10.51,10.51,0,0,0-1.08-.38c-.4-.12-.74-.13-.85,0s0,.1,0,.22a1.89,1.89,0,0,0,.41.34,9.73,9.73,0,0,0,1,.61,10.17,10.17,0,0,0,1.81.78A13.15,13.15,0,0,1,157.25,440.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,441a3.15,3.15,0,0,1-.43-1.86,6.7,6.7,0,0,1,.34-2.07,7.18,7.18,0,0,1,.53-1.13,1.59,1.59,0,0,1,1.25-.92.9.9,0,0,1,.78.57,2.49,2.49,0,0,1,.16.7,4.18,4.18,0,0,1,0,1.28,4.38,4.38,0,0,1-.89,1.93c-.78,1-1.56,1.15-1.58,1.09s.6-.43,1.21-1.36a4.32,4.32,0,0,0,.67-1.76,4,4,0,0,0,0-1.1c-.05-.4-.19-.74-.34-.7s-.52.28-.69.6a7.36,7.36,0,0,0-.51,1,7.11,7.11,0,0,0-.44,1.88C156.93,440.27,157.1,441,157,441Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.72,219.3s-6,.27-10,20.79S74.23,426.88,74.23,426.88l22.11.2L138,269l-2.77,163,22.46,1.72s16.85-180.29,17-190.78c.2-13.08-7.31-26.31-7.31-26.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.11,217.55c.14,0-2.16,11.75-5.13,26.18s-5.49,26.11-5.63,26.08,2.15-11.75,5.12-26.18S149,217.52,149.11,217.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.55,220.48c0-.06.6-.24,1.29.37a1.83,1.83,0,0,1,.6,1.41,1.77,1.77,0,0,1-1.13,1.52,1.79,1.79,0,0,1-1.88-.25,1.87,1.87,0,0,1-.59-1.42c0-.92.62-1.24.63-1.18a2.85,2.85,0,0,0-.26,1.17,1.53,1.53,0,0,0,.53,1.06,1.43,1.43,0,0,0,2.22-.93,1.52,1.52,0,0,0-.38-1.12C153.09,220.54,152.54,220.56,152.55,220.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6,228.6c0-.06.62,0,1,.83a1.76,1.76,0,0,1-.07,1.48,1.76,1.76,0,0,1-3.1-.25,1.74,1.74,0,0,1,.17-1.46c.47-.75,1.11-.73,1.09-.67s-.48.2-.77.84a1.48,1.48,0,0,0,0,1.12,1.33,1.33,0,0,0,2.24.18,1.49,1.49,0,0,0,.13-1.12C152,228.87,151.55,228.67,151.6,228.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.41,220.68a3.83,3.83,0,0,1-.26,1,16.67,16.67,0,0,1-1.17,2.65,19.43,19.43,0,0,1-15.38,10.13,16.64,16.64,0,0,1-2.89,0,4,4,0,0,1-1-.16c0-.1,1.51.07,3.9-.23a20.29,20.29,0,0,0,15.1-9.95C129.88,222.1,130.32,220.65,130.41,220.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.43,235.27s-.26-.12-.67-.4a12,12,0,0,1-1.6-1.38,17,17,0,0,1-4.89-12.69,11,11,0,0,1,.27-2.09c.11-.49.18-.75.22-.74s-.12,1.09-.12,2.84a18.54,18.54,0,0,0,4.79,12.43C172.6,234.53,173.48,235.19,173.43,235.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,235.85c.33-.8.24-.48-5.06-4,0,0,7.6,5,6.81,2.62a9.7,9.7,0,0,0-2.47-2.29c2,1.18,3.16,1.31,3.51.83.6-.83-3.75-4-5.82-5.43a49.83,49.83,0,0,0,5.94,3.65c1.23.38.64-1.06-.19-2.11s-7.27-7.25-9-9.1a1.5,1.5,0,0,1,0-2.28c3.1-2,4.46-5.19,4.42-6.24a1.13,1.13,0,0,0-2.12-.36,13.72,13.72,0,0,1-2.71,2.56,8.86,8.86,0,0,1-2.62,1.41c-1.1.36-6.51.06-7.67-.53l-3.69,12.51s13.39,6.26,15.93,7.48C249.38,236.05,250.77,236.46,251,235.85Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.53,230c-.11.15,1.63,1.42,3.88,2.85s4.14,2.46,4.23,2.31-1.65-1.43-3.89-2.85S243.63,229.81,243.53,230Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.79,227.55c-.1.15,1.68,1.61,4,3.27s4.24,2.89,4.34,2.75-1.67-1.61-4-3.27S244.9,227.41,244.79,227.55Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.12,225.07c-.1.14,1.56,1.56,3.71,3.16s4,2.78,4.08,2.64-1.55-1.56-3.7-3.16S246.23,224.93,246.12,225.07Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.93,179.76l9.82.54a49.32,49.32,0,0,0,2.78,8c7.91-13.72,14-32.11,15.56-39.5q-.33-1.09-.81-2.46a10.44,10.44,0,0,1,.12-4.16c.27-1.64.73-3.86.86-4.88.43-3.12.93-3.62,2-3.26,1.48.48-.61,8.77.6,8.95.66.09,1.45-2.75,1.69-5.08s1.28-9.49,2.05-10c1.13-.7,2.11.41,1.83,2.73s-.65,9.35.58,9.44,2.23-11.79,2.23-11.79-.19-2.58,1.23-2.52c2.57.11.57,12.64.35,13.83-.16.82,1.18,1,1.3.08s.74-11.89,3.35-11.8c2,.07-1.55,10.32-.42,12.7s1.91-8.07,3.83-7.93c.71.06,1.24.2-.07,6.11a134.8,134.8,0,0,1-4.59,13.86c-3,16.4-16.39,68.86-37.31,59.26-11.7-5.37-17.17-32-17.17-32Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.24,152.71a1.41,1.41,0,0,1,.1-.36c.09-.26.2-.6.35-1,.33-.95.78-2.27,1.37-4s1.3-3.83,2-6.31c.36-1.23.66-2.57.93-4,.14-.72.27-1.46.36-2.22a8.55,8.55,0,0,0,0-1.13c0-.39-.09-.71-.4-.72s-.53.18-.75.51a6.21,6.21,0,0,0-.49,1.11c-.28.79-.5,1.63-.72,2.48s-.42,1.74-.68,2.64a4.11,4.11,0,0,1-.6,1.38.55.55,0,0,1-.27.17.45.45,0,0,1-.38-.09,1.29,1.29,0,0,1-.28-.37,2.86,2.86,0,0,1-.21-.77,24.72,24.72,0,0,1,.6-6c.17-1,.35-2,.48-3,.06-.51.12-1,.13-1.54s-.07-1.11-.28-1.2-.72.19-1,.61a6.12,6.12,0,0,0-.65,1.42,20.75,20.75,0,0,0-.77,3.2c-.19,1.1-.34,2.22-.47,3.36-.05.57-.11,1.14-.16,1.72l-.08.87a1.27,1.27,0,0,1-.4,1,1,1,0,0,1-1.18,0,.82.82,0,0,1-.36-.57,1.13,1.13,0,0,1,0-.32l0-.21.27-1.75c.17-1.18.31-2.36.42-3.56s.2-2.41.22-3.62a12,12,0,0,0-.36-3.56,1.19,1.19,0,0,0-.5-.72.6.6,0,0,0-.67.22,3.27,3.27,0,0,0-.38,1.94v0c-.22,2.35-.47,4.66-.81,6.93-.17,1.13-.36,2.26-.64,3.37-.08.27-.16.55-.26.83a1.68,1.68,0,0,1-.57.86.6.6,0,0,1-.73-.16,1.2,1.2,0,0,1-.27-.45,4.07,4.07,0,0,1-.23-.86,33.43,33.43,0,0,1-.06-6.55,17.28,17.28,0,0,0,.17-3.07,1.7,1.7,0,0,0-.56-1.14.67.67,0,0,0-.52-.08,1.59,1.59,0,0,0-.27.12c-.09.08-.08,0-.14.17a13.65,13.65,0,0,0-.79,2.79c-.2,1-.37,1.91-.52,2.85s-.29,1.86-.41,2.78-.18,1.82-.36,2.72a14.87,14.87,0,0,1-.7,2.58,5,5,0,0,1-.29.62c-.14.19-.22.43-.6.55a.5.5,0,0,1-.51-.22,1.48,1.48,0,0,1-.16-.37,4,4,0,0,1-.08-.66c0-1.71.23-3.27.32-4.78a12.06,12.06,0,0,0,0-2.17c0-.32-.15-.7-.33-.77a.92.92,0,0,0-.81,0,2.81,2.81,0,0,0-.74,1.64c-.15.61-.21,1.23-.32,1.82-.42,2.36-.86,4.4-1.07,6.06a8.22,8.22,0,0,0,0,2.2c.14.6.35,1.14.46,1.56s.22.72.29,1a1.76,1.76,0,0,1,.08.33,1.31,1.31,0,0,1-.14-.31l-.34-1c-.14-.43-.35-.91-.52-1.57a8,8,0,0,1,0-2.26c.19-1.69.59-3.71,1-6.08.11-.59.17-1.21.3-1.85a9.43,9.43,0,0,1,.27-1,1.7,1.7,0,0,1,.62-.91,1.26,1.26,0,0,1,1.18,0A1.35,1.35,0,0,1,141,135a12.18,12.18,0,0,1,0,2.26c-.07,1.52-.31,3.11-.27,4.73a3.42,3.42,0,0,0,.07.57c0,.19.14.27.12.23s.19-.16.27-.32a4.64,4.64,0,0,0,.26-.55,13.48,13.48,0,0,0,.65-2.5c.17-.87.23-1.77.35-2.7s.24-1.85.39-2.8.32-1.9.51-2.87a13,13,0,0,1,.84-2.95,1,1,0,0,1,.35-.39,1.94,1.94,0,0,1,.42-.17,1.22,1.22,0,0,1,1,.15,2.16,2.16,0,0,1,.81,1.52,6,6,0,0,1,0,1.64c-.05.51-.1,1-.13,1.56a31.86,31.86,0,0,0,.06,6.4,4,4,0,0,0,.2.74.68.68,0,0,0,.15.26s0,0,.05,0h0c0,.23,0,0,0,.09s0,0,0-.08a2,2,0,0,0,.29-.55q.14-.37.24-.78c.27-1.06.45-2.18.62-3.3.34-2.25.59-4.56.8-6.9v.05a3.86,3.86,0,0,1,.51-2.37,1.25,1.25,0,0,1,1.39-.41,1.79,1.79,0,0,1,.86,1.1,12.54,12.54,0,0,1,.39,3.77c0,1.24-.11,2.46-.22,3.67s-.26,2.4-.43,3.58c-.09.6-.18,1.18-.27,1.77-.08.37-.06.38,0,.49a.42.42,0,0,0,.47,0c.12-.09.14-.26.17-.59l.07-.87.18-1.73c.12-1.14.28-2.28.47-3.39a22.87,22.87,0,0,1,.8-3.29,7.29,7.29,0,0,1,.73-1.55,2.23,2.23,0,0,1,.64-.66,1.1,1.1,0,0,1,1-.15,1.17,1.17,0,0,1,.55.88,4.91,4.91,0,0,1,.05.85c0,.55-.07,1.08-.13,1.61-.14,1-.33,2.06-.51,3.07a25.22,25.22,0,0,0-.62,5.79,2.58,2.58,0,0,0,.16.61,1.15,1.15,0,0,0,.13.2s0,0,0,0,0,0,0,0,0,0,0-.07a4,4,0,0,0,.49-1.17c.26-.87.47-1.75.7-2.61a25.55,25.55,0,0,1,.75-2.53,6.24,6.24,0,0,1,.54-1.18,1.91,1.91,0,0,1,.46-.53.83.83,0,0,1,.35-.18,1.26,1.26,0,0,1,.39,0,.77.77,0,0,1,.63.46,1.84,1.84,0,0,1,.13.66,7.88,7.88,0,0,1-.07,1.21c-.09.78-.24,1.52-.38,2.25-.29,1.43-.61,2.79-1,4-.75,2.48-1.5,4.58-2.11,6.29s-1.13,3-1.48,3.92c-.17.42-.31.75-.41,1A2.17,2.17,0,0,1,154.24,152.71Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.65,180.89c1.9,6.71,5.62,17.06,9.61,28a1.89,1.89,0,0,0,3.49.17l9.78-20.69s-2.36-17-2.16-16.39-20.18,2.2-20.18,2.2Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.69,177.56c0,.08-1.22.44-3.15,1.18a44.49,44.49,0,0,0-7.26,3.54,45.54,45.54,0,0,0-6.5,4.8c-1.55,1.37-2.44,2.31-2.5,2.25s.17-.28.55-.73a24.08,24.08,0,0,1,1.7-1.79,37.51,37.51,0,0,1,6.48-5,38.16,38.16,0,0,1,7.4-3.44,23.16,23.16,0,0,1,2.38-.68A2.86,2.86,0,0,1,121.69,177.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.57,182.72a10.61,10.61,0,0,1-1.64-2.14,36.56,36.56,0,0,1-3-5.74,36,36,0,0,1-1.93-6.2,10.22,10.22,0,0,1-.35-2.66,18.48,18.48,0,0,1,.71,2.57,50,50,0,0,0,2,6.09,51.12,51.12,0,0,0,2.86,5.75A21,21,0,0,1,125.57,182.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.09,91.1a22,22,0,0,0-1.91,18.81c1,2.75,2.6,5.46,2.31,8.38s-2.57,5.81-1.77,8.69c.48,1.71,1.94,3,2.51,4.66.65,2,0,4.11-.35,6.16-.8,5.24.88,10.51,1.29,15.79s-1,11.47-5.72,13.77c-1.43.7-3.3.9-4.49-.17-1.52-1.35-1.1-3.79-.68-5.79,4.14-20-8.65-39.52-5.73-59.76.47-3.24,2.28-8.74,4.61-11s8.8-2,11,.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.39,149.12s.61-.72,1.51-2.14a19.39,19.39,0,0,0,2.61-6.55,19.92,19.92,0,0,0,.31-4.86,51.48,51.48,0,0,1-.21-5.69,12.3,12.3,0,0,1,.57-3.06,17.06,17.06,0,0,1,1.38-2.94c1.12-1.89,2.53-3.65,3.83-5.53a15.18,15.18,0,0,0,2.72-6,18.71,18.71,0,0,0-.35-6.13,23.31,23.31,0,0,1-.44-5.68,19.11,19.11,0,0,1,1-4.88,18.55,18.55,0,0,1,3.54-6.23,13,13,0,0,1,1.36-1.39,2.68,2.68,0,0,1,.52-.43s-.67.65-1.73,2a19.2,19.2,0,0,0-4.22,11,22.77,22.77,0,0,0,.49,5.58,19,19,0,0,1,.38,6.3,15.73,15.73,0,0,1-2.8,6.17c-1.31,1.91-2.72,3.66-3.82,5.5a15.6,15.6,0,0,0-1.34,2.84,11.59,11.59,0,0,0-.57,2.94,54.22,54.22,0,0,0,.16,5.63,20,20,0,0,1-.38,4.95,18.74,18.74,0,0,1-2.8,6.59,14.53,14.53,0,0,1-1.2,1.54A3.2,3.2,0,0,1,112.39,149.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.91,150.61a3.67,3.67,0,0,1,.31-.67c.25-.47.57-1.09,1-1.87.84-1.63,2.09-4,3.32-7A30.51,30.51,0,0,0,110,130a21.5,21.5,0,0,0-.25-3.28c-.17-1.12-.43-2.25-.6-3.43a9.72,9.72,0,0,1,.08-3.68,6.58,6.58,0,0,1,2-3.21c1.88-1.71,4.15-2.83,5.33-4.84a16.37,16.37,0,0,0,1.77-6.41,25.06,25.06,0,0,1,1.38-6,21.69,21.69,0,0,1,8.09-10.22,16.74,16.74,0,0,1,1.83-1.07,3,3,0,0,1,.68-.3s-.9.48-2.39,1.54a21.85,21.85,0,0,0-5.37,5.49,21.25,21.25,0,0,0-2.44,4.71,25.45,25.45,0,0,0-1.3,6c-.3,2.13-.54,4.51-1.82,6.62s-3.62,3.31-5.41,5a6.12,6.12,0,0,0-1.89,3,9.26,9.26,0,0,0-.07,3.48c.16,1.15.41,2.29.58,3.42a20.29,20.29,0,0,1,.24,3.36,30.36,30.36,0,0,1-2.59,11.25,67.08,67.08,0,0,1-3.48,7L103.31,150A3.45,3.45,0,0,1,102.91,150.61Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.77,433.18a2.35,2.35,0,0,1,.18-.42c.14-.3.33-.7.56-1.21a29.54,29.54,0,0,0,1.67-4.84c1.1-4.3,1.49-10.87-.14-18.67a100.91,100.91,0,0,0-3.47-12.55c-1.46-4.45-3.17-9.17-4.56-14.28a55.38,55.38,0,0,1-2.25-16.42c.21-5.81,1.93-11.6,3.82-17.38S433.42,336,434,330.3a26.11,26.11,0,0,0-3.14-15.8c-2.5-4.61-5.65-8.56-8-12.64a44,44,0,0,1-4.81-12.16,45.33,45.33,0,0,1-.31-18.82,34.68,34.68,0,0,1,2-6.65,2.57,2.57,0,0,1-.12.44l-.4,1.27c-.34,1.12-.79,2.8-1.22,5a46,46,0,0,0,.49,18.69,43.51,43.51,0,0,0,4.83,12c2.35,4,5.51,8,8.07,12.63a26.64,26.64,0,0,1,3.23,16.13c-.59,5.78-2.55,11.47-4.44,17.24s-3.59,11.5-3.8,17.21a54.63,54.63,0,0,0,2.2,16.26c1.37,5.08,3.05,9.8,4.5,14.27a98.25,98.25,0,0,1,3.4,12.62c1.59,7.86,1.14,14.5,0,18.81a27.84,27.84,0,0,1-1.79,4.83l-.62,1.19A2.06,2.06,0,0,1,433.77,433.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.06,305.89s-4.78-15.31,3.8-24.27a.53.53,0,0,1,.91.26C431.23,284.41,431.8,292.11,426.06,305.89Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.93,286.72a14.65,14.65,0,0,1-.32,2.82c-.32,1.95-.69,4.23-1.09,6.75s-.77,4.81-1.08,6.75a16.84,16.84,0,0,1-.5,2.8A11.86,11.86,0,0,1,426,303c.16-1.75.47-4.15.9-6.79s.9-5,1.27-6.73A12.4,12.4,0,0,1,428.93,286.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.68,342s2.93-15.77,14.71-19.67a.53.53,0,0,1,.68.66C446.29,325.42,443.2,332.49,431.68,342Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.18,326.38a14.81,14.81,0,0,1-1.6,2.35l-4.13,5.45-4.1,5.47a16,16,0,0,1-1.75,2.23,11.84,11.84,0,0,1,1.4-2.48c1-1.47,2.36-3.45,4-5.58s3.13-4,4.26-5.36A12.88,12.88,0,0,1,443.18,326.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.5,381.53s-1.78-15.94,8.36-23.09a.52.52,0,0,1,.84.43C437.67,361.44,436.76,369.1,428.5,381.53Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,363.26a13.32,13.32,0,0,1-.85,2.71l-2.36,6.42c-.88,2.4-1.67,4.57-2.34,6.42a16.44,16.44,0,0,1-1,2.65,11.68,11.68,0,0,1,.62-2.78c.49-1.68,1.25-4,2.18-6.5s1.84-4.75,2.53-6.36A13.93,13.93,0,0,1,435,363.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.37,421.31s-1.2-16,9.18-22.78a.53.53,0,0,1,.83.46C447.26,401.56,446.08,409.19,437.37,421.31Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.49,403.29a13.85,13.85,0,0,1-.95,2.68c-.74,1.82-1.62,4-2.59,6.33s-1.82,4.5-2.56,6.33a15.56,15.56,0,0,1-1.13,2.61,12,12,0,0,1,.73-2.76c.55-1.66,1.39-3.94,2.41-6.41s2-4.69,2.75-6.27A13.36,13.36,0,0,1,444.49,403.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.18,292.44S405,285,404.69,272.61a.54.54,0,0,1,.83-.46C407.63,273.61,413.49,278.65,419.18,292.44Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.64,276.87a13.75,13.75,0,0,1,1.77,2.23c1.16,1.59,2.51,3.47,4,5.54l4,5.52a15.67,15.67,0,0,1,1.62,2.33,11.76,11.76,0,0,1-1.95-2.07c-1.13-1.34-2.61-3.26-4.17-5.43s-2.93-4.18-3.87-5.65A13.66,13.66,0,0,1,407.64,276.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.45,325.31s-14.64-6.55-15.67-18.92a.53.53,0,0,1,.8-.5C421.77,307.22,427.92,311.88,434.45,325.31Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,310.47a13.57,13.57,0,0,1,1.9,2.11l4.34,5.29,4.35,5.27a16,16,0,0,1,1.76,2.23,12.18,12.18,0,0,1-2.08-1.95c-1.2-1.28-2.8-3.1-4.49-5.17s-3.17-4-4.21-5.41A12.85,12.85,0,0,1,422,310.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,362s-10-12.5-5.33-24a.53.53,0,0,1,.94-.08C423,340.09,426.33,347.05,426,362Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.68,343.08a13.63,13.63,0,0,1,.74,2.75c.42,1.92.91,4.18,1.45,6.68s1.05,4.75,1.47,6.67a15.67,15.67,0,0,1,.55,2.79,12,12,0,0,1-1-2.68c-.49-1.69-1.09-4-1.65-6.66s-1-5-1.28-6.72A13,13,0,0,1,421.68,343.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,405.11s-14.53-6.79-15.35-19.17a.53.53,0,0,1,.81-.5C423.61,386.81,429.68,391.58,436,405.11Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.77,390.06a14.89,14.89,0,0,1,1.86,2.15l4.25,5.35,4.26,5.35a15.68,15.68,0,0,1,1.72,2.26,11.78,11.78,0,0,1-2-2c-1.19-1.3-2.75-3.15-4.41-5.25s-3.1-4.05-4.12-5.48A12.23,12.23,0,0,1,423.77,390.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.91,342.07s0,.12,0,.35,0,.61,0,1c0,1-.1,2.27-.17,3.89-.18,3.42-.45,8.19-.76,13.89h0v0c-1,5.8-4,12.23-8,18.48-2.91,4.6-6,8.78-8.6,12.67A89.36,89.36,0,0,0,441,403.05a44.9,44.9,0,0,0-3,7.82c-.25.95-.45,1.7-.56,2.21a4.65,4.65,0,0,1-.21.78,3.63,3.63,0,0,1,.1-.8c.07-.52.22-1.28.45-2.25a40.87,40.87,0,0,1,2.85-7.95A85.88,85.88,0,0,1,447,392.09c2.62-3.92,5.65-8.11,8.55-12.68,3.95-6.22,6.89-12.55,8-18.26v0c.4-5.69.73-10.45,1-13.87.13-1.62.24-2.91.32-3.88,0-.4.07-.74.1-1A1.32,1.32,0,0,1,464.91,342.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.26,378.53s6.15-14.8-1.58-24.51a.53.53,0,0,0-.93.18C453.06,356.68,451.79,364.29,456.26,378.53Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.14,359.19a13,13,0,0,1,.49,2.8c.22,1.74.46,4.15.65,6.82s.28,5.09.28,6.85a11.6,11.6,0,0,1-.17,2.84,15,15,0,0,1-.25-2.83c-.13-2-.29-4.27-.46-6.82s-.33-4.86-.47-6.82A14.46,14.46,0,0,1,455.14,359.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456.26,378.53s6.15-14.8-1.58-24.51a.53.53,0,0,0-.93.18C453.06,356.68,451.79,364.29,456.26,378.53Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M437.21,414.22s4.93-15.26-3.57-24.3a.53.53,0,0,0-.91.25C432.25,392.69,431.6,400.39,437.21,414.22Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.52,395a12.27,12.27,0,0,1,.72,2.76c.36,1.71.79,4.1,1.2,6.74s.69,5.05.84,6.8a12,12,0,0,1,.05,2.85,17.08,17.08,0,0,1-.48-2.8c-.29-1.95-.63-4.23-1-6.76s-.73-4.81-1-6.76A14.48,14.48,0,0,1,434.52,395Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M437.21,414.22s4.93-15.26-3.57-24.3a.53.53,0,0,0-.91.25C432.25,392.69,431.6,400.39,437.21,414.22Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M464.1,360.44s13.13-9.2,11.81-21.54a.53.53,0,0,0-.88-.34C473.12,340.28,468,346,464.1,360.44Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M464.1,360.44s13.13-9.2,11.81-21.54a.53.53,0,0,0-.88-.34C473.12,340.28,468,346,464.1,360.44Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M473.53,343.51a12.33,12.33,0,0,1-1.09,2.63c-.75,1.58-1.84,3.74-3.11,6.1s-2.49,4.45-3.43,5.93a11.86,11.86,0,0,1-1.67,2.3,14.73,14.73,0,0,1,1.3-2.52c.94-1.73,2.05-3.75,3.27-6l3.26-6A14.61,14.61,0,0,1,473.53,343.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.51,399.09s15.84-2.47,20.08-14.13a.53.53,0,0,0-.63-.7C459.49,385,452.33,387.85,442.51,399.09Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M442.51,399.09s15.84-2.47,20.08-14.13a.53.53,0,0,0-.63-.7C459.49,385,452.33,387.85,442.51,399.09Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M458.43,388.05a12.84,12.84,0,0,1-2.14,1.87c-1.37,1.1-3.3,2.56-5.47,4.12s-4.2,2.89-5.7,3.81a11.57,11.57,0,0,1-2.52,1.33,15.44,15.44,0,0,1,2.29-1.69l5.58-3.94,5.57-4A13.29,13.29,0,0,1,458.43,388.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.39 428.25 422.77 459.35 451.57 459.35 447.84 428.25 427.39 428.25",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,437.88c0,.17-5.2.3-11.61.3s-11.62-.13-11.62-.3a114.71,114.71,0,0,1,11.62-.3A114.58,114.58,0,0,1,449,437.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.56,440.36c0,.17-5.37.3-12,.3s-12-.13-12-.3,5.37-.3,12-.3S449.56,440.19,449.56,440.36Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boxes--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.57,126.54s-.27,0-.79,0a19.23,19.23,0,0,0-2.28,0,25.62,25.62,0,0,0-8.53,2,26.19,26.19,0,0,0-10.82,8.43,23.63,23.63,0,0,0-3.78,7.73A26,26,0,0,0,314,164.34a22.22,22.22,0,0,0,3.4,4.52,18.48,18.48,0,0,0,4.6,3.6,11.3,11.3,0,0,0,5.77,1.45,8.29,8.29,0,0,0,5.59-2.26,8.07,8.07,0,0,0,2.23-5.76,10.62,10.62,0,0,0-2-6.13c-2.59-3.65-6.79-6.1-11.26-7.42a27.65,27.65,0,0,0-14.2-.2,29.76,29.76,0,0,0-6.84,2.72,24.65,24.65,0,0,0-5.87,4.61c-.41.47-.88.9-1.25,1.42l-1.13,1.52a28.55,28.55,0,0,0-1.84,3.34,27.1,27.1,0,0,0-2.17,7.37,27.94,27.94,0,0,0,2,15,23.17,23.17,0,0,0,9.65,11,16,16,0,0,0,6.84,2.07,12.08,12.08,0,0,0,6.75-1.62,10.55,10.55,0,0,0,4.56-5A9.06,9.06,0,0,0,319,188a13.23,13.23,0,0,0-3.76-5.32,17.22,17.22,0,0,0-5.53-3.21,21.43,21.43,0,0,0-12.18-.21,23.73,23.73,0,0,0-10,5.57,22.84,22.84,0,0,0-5.73,8.87,25.7,25.7,0,0,0,.27,18,27.29,27.29,0,0,0,8.23,11,29.61,29.61,0,0,0,7.57,4.41c.94.35,1.67.61,2.17.75l.74.24s-.26-.05-.76-.19a21.51,21.51,0,0,1-2.18-.71,28.33,28.33,0,0,1-7.66-4.34,27.41,27.41,0,0,1-8.39-11.05,26,26,0,0,1-.33-18.19,22.93,22.93,0,0,1,5.79-9,24.19,24.19,0,0,1,10.15-5.7,21.89,21.89,0,0,1,12.44.2,17.52,17.52,0,0,1,5.69,3.29,13.58,13.58,0,0,1,3.9,5.51,9.58,9.58,0,0,1-.1,6.89,11.2,11.2,0,0,1-4.77,5.21,12.62,12.62,0,0,1-7,1.7,16.26,16.26,0,0,1-7-2.14,23.64,23.64,0,0,1-9.89-11.19,28.5,28.5,0,0,1-2.06-15.28,27.86,27.86,0,0,1,2.22-7.52,28.94,28.94,0,0,1,1.88-3.41l1.16-1.55c.37-.53.85-1,1.27-1.46a25.33,25.33,0,0,1,6-4.7,30.13,30.13,0,0,1,7-2.76,28.14,28.14,0,0,1,14.47.21c4.56,1.36,8.83,3.85,11.52,7.63a11,11,0,0,1,2.1,6.4,8.54,8.54,0,0,1-2.37,6.09,8.75,8.75,0,0,1-5.9,2.37,11.63,11.63,0,0,1-6-1.51,18.59,18.59,0,0,1-4.7-3.69,23,23,0,0,1-3.45-4.61,26.37,26.37,0,0,1-2.64-20,23.9,23.9,0,0,1,3.87-7.81,26.32,26.32,0,0,1,11-8.45,25,25,0,0,1,8.59-1.88,17.47,17.47,0,0,1,2.3,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.75,
    y: 226.6,
    width: 140.21,
    height: 108.14,
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.75 226.6 256.65 250.76 394.48 250.76 370.96 226.6 230.75 226.6",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.75,226.6,371,226.35h.11l.08.07,23.28,23.91.24.25.43.44h-.62l-137.83-.11h-.06l0,0L230.75,226.6l26,24-.11,0,137.83-.1-.18.44-.25-.25-23.27-23.91.18.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.87,276.47a2.9,2.9,0,1,0,.21,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,276.47a2.89,2.89,0,1,0,.22,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.19,302.35a20.72,20.72,0,0,0-2.78-6.21,18.25,18.25,0,0,0-5.3-5.08,16.17,16.17,0,0,0-17.13-.47,18.47,18.47,0,0,0-5.57,4.78,20.5,20.5,0,0,0-3.11,6.06,2.07,2.07,0,0,1,.08-.48,11.17,11.17,0,0,1,.37-1.33,16,16,0,0,1,2.37-4.47,18.19,18.19,0,0,1,5.63-5,16.45,16.45,0,0,1,17.62.48,18.14,18.14,0,0,1,5.34,5.28,16,16,0,0,1,2.13,4.6,11.74,11.74,0,0,1,.29,1.35A2.78,2.78,0,0,1,306.19,302.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.07 227.79 255.87 259.23 370.96 259.23 370.96 250.76 256.65 250.76 231.07 227.79",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.31,334.5c-.14,0-.26-18.81-.26-42s.12-42,.26-42,.27,18.8.27,42S343.46,334.5,343.31,334.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.97,
    y: 309.98,
    width: 12.36,
    height: 13.97,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.75 226.6 201.97 250.76 230.75 250.76 230.75 226.6",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "230.75 226.6 201.97 250.76 230.75 250.76 230.75 226.6"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 213.89,
    y: 334.74,
    width: 161.21,
    height: 124.34,
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.89,
    y: 334.74,
    width: 161.21,
    height: 124.34,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.71,458.2c-.14,0-.26-27.71-.26-61.89s.12-61.9.26-61.9.26,27.71.26,61.9S334.85,458.2,334.71,458.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.07,
    y: 430.78,
    width: 12.36,
    height: 13.97,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.07,
    y: 335.07,
    width: 18.31,
    height: 26.53,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.07,
    y: 432.18,
    width: 18.31,
    height: 26.53,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.7,334.74l-.42,0-1.21,0-4.65.05-17.13.08L293.8,335l-56.51-.07-17.12-.08-4.65-.05-1.22,0-.41,0,.41,0,1.22,0,4.65-.05,17.12-.08,56.51-.08,56.49.08,17.13.08,4.65.05,1.21,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.42,119.47l-17.56-4.32.13,0a29.15,29.15,0,0,1-15.15,4.55,31.87,31.87,0,0,1-9.39-1.37A29.44,29.44,0,0,1,35.23,93.89a29,29,0,0,1,7.54-23.43A30.08,30.08,0,0,1,47.86,66c.94-.59,1.88-1.2,2.86-1.71l1.49-.72.74-.36.78-.28A29.51,29.51,0,0,1,66.35,61,29.23,29.23,0,0,1,92.11,80.7a30.46,30.46,0,0,1,1.62,9.48,29.09,29.09,0,0,1-4.21,15.21v-.16c4.88,8.81,7.34,13.26,7.89,14.24-.57-1-3.12-5.37-8.17-14.09l0-.08,0-.08a28.86,28.86,0,0,0,4-15,29.78,29.78,0,0,0-1.64-9.32A28.76,28.76,0,0,0,66.31,61.6a29,29,0,0,0-12.37,1.9l-.76.27-.73.36-1.46.7c-1,.51-1.88,1.1-2.81,1.68a29.71,29.71,0,0,0-5,4.34,28.49,28.49,0,0,0-7.41,23,28.93,28.93,0,0,0,10.83,19.23,28.47,28.47,0,0,0,9,4.8,31.16,31.16,0,0,0,9.23,1.39,28.88,28.88,0,0,0,15-4.39l.06,0H80Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,77.3,62.89,92a2.38,2.38,0,0,0,2.23,2.23h0a2.39,2.39,0,0,0,2.51-2.12l1.63-14.73a1.87,1.87,0,0,0-1.89-2.07l-3.57,0A1.86,1.86,0,0,0,62,77.3Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,102.44a3.58,3.58,0,1,1-2.27-4.53A3.58,3.58,0,0,1,69,102.44Z",
    style: {
      fill: "#002557"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPana2);
export default __webpack_public_path__ + "static/media/Empty-pana-2.f8e6b200ec99eac262e4a937cb7403ae.svg";
export { ForwardRef as ReactComponent };